import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Alert,
  Divider
} from '@mui/material';
import { Security, Lock, VpnKey } from '@mui/icons-material';

const SecurityCard = () => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Security sx={{ mr: 1 }} />
          <Typography variant="h6">
            Security Settings
          </Typography>
        </Box>

        <Alert severity="info" sx={{ mb: 3 }}>
          Security management features are being migrated to Material-UI
        </Alert>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Lock />
            Password Management
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Change your password and manage account security
          </Typography>
          <Button variant="outlined" disabled>
            Change Password
          </Button>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <VpnKey />
            Two-Factor Authentication
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add an extra layer of security to your account
          </Typography>
          <Button variant="outlined" disabled>
            Setup 2FA
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SecurityCard;